// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BU3f","colMin":"styles_colMin__2veQz"};